import React from 'react';
import { shape, string } from 'prop-types';

const ChevronLeft = ({
  className = '',
  style = {},
}) => (
  <svg className={className || ''} style={style} width="1em" height="1em" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M11.7787 5.5575L10.7212 4.5L6.22119 9L10.7212 13.5L11.7787 12.4425L8.34369 9L11.7787 5.5575Z" fill="currentColor" />
  </svg>
);

ChevronLeft.propTypes = {
  className: string,
  style: shape({}),
};

export default ChevronLeft;
